import { Modal } from '@mi-front/ui';

import { FormattedMessage } from 'react-intl';
interface HelpModal {
  show: boolean;
  onHide: () => void;
}

export const SearchHelpModal: React.FunctionComponent<HelpModal> = (props) => {
  const { show, onHide } = props;
  return (
    <Modal
      size="md"
      show={show}
      showCloseButton
      title={
        <div style={{ display: 'flex' }}>
          <FormattedMessage id="common.help" defaultMessage="Ayuda" />
        </div>
      }
      onHide={() => onHide()}
    >
      <div className={'mb-3'}>
        <FormattedMessage
          id="search.helpFistLine"
          defaultMessage="Para operaciones de busqueda avanzada:"
        />
      </div>
      <ul>
        <li>
          <FormattedMessage
            id="search.helpPlusOp"
            defaultMessage="El símbolo + corresponde al operador lógico Y (AND)"
          />
        </li>
        <li>
          <FormattedMessage
            id="search.helpVertialBarOp"
            defaultMessage="El símbolo | corresponde al operador lógico O (OR)"
          />
        </li>
      </ul>
    </Modal>
  );
};
